import { render, staticRenderFns } from "./CoverStay.vue?vue&type=template&id=480ce683&"
import script from "./CoverStay.vue?vue&type=script&lang=js&"
export * from "./CoverStay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports